import React from "react";

const Loader =()=>(
    <div className={"loader"}>
        <div className={"image"}>
            <img className={"cat"} src={"/Images/Animation/img.svg"} alt={"😼"}/>
        </div>
    </div>
)
export default Loader;